import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const sliderApi = {
  // Get all sliders for public display
  getPublicSliders: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/sliders/public`);
      return response.data;
    } catch (error) {
      console.error('Error fetching public sliders:', error);
      return { success: false, error: error.message };
    }
  },

  // Get all sliders (admin)
  getAllSliders: async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE_URL}/api/sliders`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching sliders:', error);
      return { success: false, error: error.message };
    }
  },

  // Get single slider
  getSliderById: async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_BASE_URL}/api/sliders/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching slider:', error);
      return { success: false, error: error.message };
    }
  },

  // Create slider
  createSlider: async (sliderData, imageFile) => {
    try {
      const formData = new FormData();
      
      formData.append('title', sliderData.title);
      if (sliderData.subtitle) formData.append('subtitle', sliderData.subtitle);
      formData.append('alignment', sliderData.alignment || 'center');
      formData.append('isActive', sliderData.isActive);
      formData.append('priority', sliderData.priority || 0);
      
      if (imageFile) {
        formData.append('image', imageFile);
      }

      const token = localStorage.getItem('token');
      // Don't set Content-Type manually — axios sets it automatically for
      // FormData with the correct multipart boundary.
      const response = await axios.post(`${API_BASE_URL}/api/sliders`, formData, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('Error creating slider:', error);
      throw error;
    }
  },

  // Update slider
  updateSlider: async (id, sliderData, imageFile) => {
    try {
      const formData = new FormData();
      
      formData.append('title', sliderData.title);
      if (sliderData.subtitle) formData.append('subtitle', sliderData.subtitle);
      formData.append('alignment', sliderData.alignment);
      formData.append('isActive', sliderData.isActive);
      formData.append('priority', sliderData.priority);
      
      if (imageFile) {
        formData.append('image', imageFile);
      }

      const token = localStorage.getItem('token');
      // Don't set Content-Type manually — axios sets it automatically for
      // FormData with the correct multipart boundary.
      const response = await axios.put(`${API_BASE_URL}/api/sliders/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('Error updating slider:', error);
      throw error;
    }
  },

  // Delete slider
  deleteSlider: async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.delete(`${API_BASE_URL}/api/sliders/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting slider:', error);
      throw error;
    }
  },

  // Update slider priority
  updateSliderPriority: async (id, priority) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(`${API_BASE_URL}/api/sliders/${id}/priority`, { priority }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating slider priority:', error);
      throw error;
    }
  }
};
